<div class="relative min-h-screen overflow-hidden bg-gradient-to-b from-midnight via-midnight-soft/95 to-[#080d17]">
    <div class="pointer-events-none absolute inset-0">
        <div class="absolute inset-0 bg-grid-radial opacity-70"></div>
        <div class="absolute -top-48 right-[-12%] h-[480px] w-[480px] rounded-full bg-aurora-sheen blur-3xl opacity-80"></div>
        <div
            class="absolute bottom-[-18%] left-[-15%] h-[420px] w-[420px] rounded-full bg-[radial-gradient(circle_at_center,_rgba(75,243,193,0.35),_rgba(5,11,25,0)_65%)] blur-3xl opacity-80">
        </div>
        <div class="absolute inset-0 bg-[radial-gradient(circle_at_50%_20%,rgba(75,99,243,0.08),transparent_55%)]"></div>
    </div>

    <header class="relative border-b border-white/5">
        <div class="container flex items-center justify-between py-3">
            <div class="flex items-center gap-4">
                <span class="flex h-16 w-16 items-center justify-center">
                    <img alt="Brisar Express" src="https://brisar.net/assets/img/logo.png">
                </span>
                <div>
                    <p class="text-xl font-semibold text-white">Brisar Express</p>
                    <p class="text-xs uppercase tracking-[0.38em] text-white/50">
                        Global Tracking
                    </p>
                </div>
            </div>
            <!--
      <div
        class="hidden items-center gap-6 text-sm font-medium text-white/70 lg:flex"
      >
        <button
          type="button"
          class="transition-colors duration-200 hover:text-white"
        >
          Seguimiento
        </button>
        <button
          type="button"
          class="transition-colors duration-200 hover:text-white"
        >
          Soporte
        </button>
      </div>
      <div class="flex items-center gap-3">
        <button
          type="button"
          class="hidden rounded-full border border-white/20 px-5 py-2 text-sm font-semibold text-white/80 transition-all duration-200 hover:border-brand-emerald/60 hover:text-white lg:inline-flex"
        >
          Iniciar sesión
        </button>
        <button type="button" class="btn-primary">Crear cuenta</button>
      </div>
      -->
        </div>
    </header>

    <main class="relative">
        <div class="container grid gap-14 py-6 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:py-6">
            <section class="space-y-6">
                <span class="tag">Seguimiento sin fronteras</span>
                <h1 class="max-w-2xl text-2xl font-semibold leading-tight text-white sm:text-5xl lg:text-3xl">
                    Consulta el recorrido completo de tus envíos internacionales
                </h1>
                <p class="max-w-xl text-lg text-white/70">
                    Introduce tu número de tracking y obtén una trazabilidad detallada en
                    tiempo real, diseñada para equipos que necesitan visibilidad
                    inmediata.
                </p>
                <div class="frosted-card p-6">
                    <div class="flex flex-wrap items-center justify-between gap-4">
                        <div>
                            <h2 class="text-xl font-semibold text-white">
                                Rastrea tu paquete
                            </h2>
                            <p class="text-sm text-white/60">
                                Seguimiento global con actualizaciones minuto a minuto.
                            </p>
                        </div>
                        <span class="hidden rounded-full bg-brand-emerald/15 px-4 py-1 text-sm font-semibold text-brand-emerald lg:inline-flex">Monitoreo
                            24/7</span>
                    </div>
                    <form class="mt-6 flex flex-col gap-4 lg:flex-row">
                        <label class="flex-1">
                            <span class="text-xs uppercase tracking-[0.24em] text-white/60">Número de tracking</span>
                            <div
                                class="mt-2 flex items-center gap-3 rounded-full border border-white/15 bg-white/[0.04] px-5 py-3 transition-all duration-200 focus-within:border-brand-emerald/70 focus-within:bg-white/[0.08]">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    class="h-5 w-5 text-brand-emerald/80">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" d="M4 7h16M4 12h16M4 17h10" />
                                </svg>
                                <input #trackingInput type="text" inputmode="text" autocomplete="off" placeholder="Ej. RZ472910345US"
                                    class="w-full bg-transparent text-base text-white placeholder-white/40 focus:outline-none" />
                            </div>
                        </label>
                        <button type="button" class="btn-primary w-full lg:w-auto" (click)="fetchTracking(trackingInput.value)" [disabled]="loading">
                            @if(!loading){
                            <span>Ver estado</span>
                            }
                            @else {
                            <span>Cargando...</span>
                            }
                        </button>
                    </form>
                    @if(error) {
                    <p class="mt-2 text-sm text-red-400">{{ error }}</p>
                    }
                    @if(events.length > 0) {
                    <div class="mt-6 grid gap-4 sm:grid-cols-2">
                        <div class="rounded-2xl border border-white/10 bg-white/[0.03] p-4">
                            <p class="text-xs uppercase tracking-[0.24em] text-white/60">
                                Última actualización
                            </p>
                            <p class="mt-2 text-base font-semibold text-white">
                                {{ lastUpdate || '—' }}
                            </p>
                            <p class="text-xs text-white/60">{{ lastUpdate ? '' : 'Sin fecha' }}</p>
                        </div>
                        <div class="rounded-2xl border border-white/10 bg-white/[0.03] p-4">
                            <p class="text-xs uppercase tracking-[0.24em] text-white/60">
                                Estado actual
                            </p>
                            <p class="mt-2 text-base font-semibold text-brand-emerald">
                                {{ status || '—' }}
                            </p>
                            <p class="text-xs text-white/60">&nbsp;</p>
                        </div>
                    </div>
                    }
                </div>
            </section>

            <section class="frosted-card relative flex h-full flex-col overflow-hidden">
                <div class="absolute inset-x-0 -top-28 h-48 bg-aurora-sheen blur-3xl opacity-60"></div>
                <div class="relative flex items-center justify-end px-6 pt-6 text-xs text-white/60">
                    @if(events.length > 0) {
                    @if(isDelayed) {
                    <span class="inline-flex items-center gap-2 rounded-full bg-amber-500/15 px-3 py-1 text-[0.7rem] font-semibold text-amber-400">
                        <span class="h-2 w-2 rounded-full bg-amber-400 animate-[ping_1.6s_ease-out_infinite]"></span>
                        Demorado
                    </span>
                    }
                    @else {
                    <span class="inline-flex items-center gap-2 rounded-full bg-brand-emerald/15 px-3 py-1 text-[0.7rem] font-semibold text-brand-emerald">
                        <span class="h-2 w-2 rounded-full bg-brand-emerald animate-[ping_1.6s_ease-out_infinite]"></span>
                        En tránsito
                    </span>
                    }
                    }
                </div>
                <div class="relative px-6 pt-5">
                    <h3 class="text-2xl font-semibold text-white">Guía {{ trackingNumber || '' }}</h3>
                    <!-- <p class="mt-1 text-sm text-white/60">
                        {{ lastUpdate ? ('Revisión automática ' + lastUpdate) : 'Sin revisiones recientes' }}
                    </p> -->
                </div>
                <div class="relative mt-6 flex-1 overflow-hidden">
                    <div class="max-h-[500px] overflow-y-auto px-2 pb-8">
                        <ol class="relative space-y-8 px-6">
                            @if(events.length === 0) {
                            <li class="text-sm text-white/60">No hay eventos para este número.</li>
                            }
                            @else {
                            @for (e of events; track $index) {
                            <li class="relative pl-10 after:absolute after:left-[26px] after:top-[34px] after:h-[calc(100%-34px)] after:w-px after:bg-white/12">
                                <span class="absolute left-0 top-1 flex h-7 w-7 items-center justify-center rounded-full border event-icon"
                                    [attr.data-code]="e.TipoSeguimiento || 'default'">
                                    @if(e.iconHtml) {
                                    <span [innerHTML]="e.iconHtml" class="h-4 w-4"></span>
                                    }
                                    @else {
                                    <img *ngIf="!e.iconHtml" [src]="e.icon || ('/icons/' + (e.TipoSeguimiento || 'default') + '.svg')" alt="{{ e.Titulo }}"
                                        class="h-4 w-4 object-contain" />
                                    }
                                </span>

                                <!-- <span
                  class="absolute left-0 top-1 flex h-7 w-7 items-center justify-center rounded-full border border-brand-sky/40 bg-brand-sky/15 text-brand-sky"
                >
                <span
                  class="absolute left-0 top-1 flex h-7 w-7 items-center justify-center rounded-full border border-brand-emerald/40 bg-brand-emerald/15 text-brand-emerald"
                > -->

                                <p class="text-sm font-semibold text-white">{{ e.Titulo }}</p>
                                <p class="text-xs text-white/60">{{ e.localDate }}</p>
                                @if(e.Descripcion) {
                                <p class="mt-2 text-xs text-white/70">{{ e.Descripcion }}</p>
                                }
                            </li>
                            }
                            }
                        </ol>
                    </div>
                </div>

                @if(events.length > 0) {
                <div class="relative mt-auto px-6 pb-6">
                    <div class="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-4">
                        <div>
                            <p class="text-sm text-white/70">Entrega estimada</p>
                            <p class="text-lg font-semibold text-brand-emerald">
                                {{estimatedDeliveryDate }}
                            </p>
                        </div>
                        <div class="text-right text-xs text-white/60">
                            <p>Notificaciones activas</p>
                            <p class="text-white">SMS · Email</p>
                        </div>
                    </div>
                </div>
                }
            </section>
        </div>

        <section class="container pb-4">
            <div
                class="frosted-card flex flex-col gap-10 rounded-[32px] border border-white/10 bg-white/[0.05] p-6 shadow-inner-card lg:flex-row lg:items-center lg:gap-16">
                <div class="flex-1 space-y-5">
                    <h2 class="text-3xl font-semibold text-white">
                        ¿Necesitas ayuda con tu envío?
                    </h2>
                    <p class="text-base text-white/60">
                        Nuestro equipo de soporte responde en minutos con acceso directo a
                        la trazabilidad de tu paquete. Escríbenos para resolver incidencias
                        o solicitar actualizaciones personalizadas.
                    </p>
                </div>
                <div class="flex w-full flex-col gap-4 lg:w-[340px]">
                    <a href="https://wa.me/13057714429?text=Hola%2C%20necesito%20ayuda%20con%20mi%20env%C3%ADo%20RZ472910345US." target="_blank"
                        class="flex items-center justify-between rounded-2xl border border-brand-emerald/30 bg-brand-emerald/15 px-5 py-4 text-left transition-transform duration-300 ease-swift hover:-translate-y-0.5 hover:border-brand-emerald/60">
                        <div>
                            <p class="text-sm font-semibold text-brand-emerald">
                                WhatsApp prioritario
                            </p>
                            <p class="text-xs text-brand-emerald/80">
                                Tiempo medio de respuesta: 4 min
                            </p>
                        </div>
                        <span class="flex h-10 w-10 items-center justify-center rounded-full bg-brand-emerald text-midnight">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" class="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                                    d="M16.012 14.408c-.27-.135-1.598-.789-1.846-.879-.248-.09-.43-.135-.612.136-.181.27-.702.879-.861 1.06-.158.18-.317.203-.587.068-.27-.135-1.14-.42-2.172-1.34-.803-.717-1.345-1.605-1.503-1.876-.158-.27-.017-.416.119-.551.122-.121.27-.316.404-.473.135-.158.18-.27.27-.45.09-.18.045-.338-.022-.473-.068-.135-.612-1.477-.84-2.028-.221-.531-.446-.459-.612-.468l-.523-.009c-.18 0-.473.068-.72.338-.248.27-.95.928-.95 2.261 0 1.334.974 2.625 1.109 2.805.135.18 1.918 2.927 4.65 4.107 2.732 1.18 2.732.792 3.226.743.495-.045 1.598-.654 1.823-1.287.225-.633.225-1.176.158-1.287-.068-.111-.248-.18-.518-.315z" />
                            </svg>
                        </span>
                    </a>
                    <a href="mailto:cliente@ibrisar.com" target="_blank"
                        class="flex items-center justify-between rounded-2xl border border-white/15 bg-white/[0.04] px-5 py-4 text-left transition-transform duration-300 ease-swift hover:-translate-y-0.5 hover:border-brand-sky/50">
                        <div>
                            <p class="text-sm font-semibold text-white">Correo dedicado</p>
                            <p class="text-xs text-white/60">cliente@ibrisar.com</p>
                        </div>
                        <span class="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" class="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" d="M3 7l9 6 9-6m-18 0v10h18V7" />
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </section>
    </main>

    <footer class="relative border-t border-white/5">
        <div class="container flex flex-col gap-6 py-8 text-sm text-white/55 sm:flex-row sm:items-center sm:justify-between">
            <p>© 2024 Brisar Express. Todos los derechos reservados.</p>
            <!-- <div class="flex flex-wrap items-center gap-5">
                <span>Privacidad</span>
                <span>Centro de ayuda</span>
            </div> -->
        </div>
    </footer>
</div>